import * as React from 'react';
import { Card } from '@newcore/ui/card';

interface OnboardingPageLayoutProps {
  children: React.ReactNode;
}

export const OnboardingPageLayout: React.FC<OnboardingPageLayoutProps> = ({
  children,
}): React.ReactElement => (
  <div className='min-h-screen flex items-center justify-center bg-primary px-4'>
    <Card className='w-full max-w-md'>{children}</Card>
  </div>
);
